import type { ImageSource } from "@/lib/images";

type OptimizedImageProps = {
  sources: ImageSource[];
  src: string;
  srcSet?: string;
  sizes: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
  pictureClassName?: string;
  fetchPriority?: "high" | "low" | "auto";
  loading?: "eager" | "lazy";
};

export function OptimizedImage({
  sources,
  src,
  srcSet,
  sizes,
  alt,
  width,
  height,
  className,
  pictureClassName,
  fetchPriority,
  loading,
}: OptimizedImageProps) {
  return (
    <picture className={pictureClassName}>
      {sources.map((source) => (
        <source key={source.type} type={source.type} srcSet={source.srcSet} sizes={sizes} />
      ))}
      <img
        src={src}
        srcSet={srcSet}
        sizes={sizes}
        alt={alt}
        width={width}
        height={height}
        className={className}
        fetchPriority={fetchPriority}
        loading={loading}
        decoding="async"
      />
    </picture>
  );
}
